import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

$(document).ready(function () {
    "use strict";

    /*==============================
    Menu
    ==============================*/
    $('.header__btn').on('click', function() {
        $(this).toggleClass('header__btn--active');
        $('.sidebar').toggleClass('sidebar--active');
    });

    $('.header__search .close, .header__action--search button').on('click', function() {
        $('.header__search').toggleClass('header__search--active');
    });

    /*==============================
    Filter
    ==============================*/
    $('.filter__item-menu li').each(function() {
        $(this).attr('data-value', $(this).text().toLowerCase());
    });

    $('.filter__item-menu li').on('click', function() {
        const text = $(this).text();
        const id = $(this).closest('.filter').attr('id');
        $('#' + id).find('.filter__item-btn input').val(text);
    });

    /*==============================
    Modal
    ==============================*/
    if ($('.open-video, .open-map').length) {
        $('.open-video, .open-map').magnificPopup({
            disableOn: 0,
            fixedContentPos: true,
            type: 'iframe',
            preloader: false,
            removalDelay: 300,
            mainClass: 'mfp-fade',
        });
    }

    if ($('.open-modal').length) {
        $('.open-modal').magnificPopup({
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'auto',
            type: 'inline',
            preloader: false,
            focus: '#username',
            modal: false,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in',
        });
    }

    $('.modal__close').on('click', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
});
